import classNames from "classnames/bind";
import { H4, SubText } from "common/components/Typography";
import { urls } from "common/urls";
import { useElements } from "domain/pages/ElementPage";
import { SelfAssessmentDelivery } from "domain/self-assessment/SelfAssessmentDelivery";
import React from "react";
import { Link } from "react-router-dom";
import { KurssloeyfeElementNavList } from "./KurssloeyfeElementNavList";
import styles from "./KurssloeyfeSidebar.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  containerId: string;
  canUpdateDetails: boolean;
  title: string;
  progress?: React.ReactNode;
}

export const KurssloeyfeSidebar: React.FC<React.PropsWithChildren<Props>> = ({
  containerId,
  canUpdateDetails,
  title,
  progress,
  children,
}) => {
  const { containerType } = useElements();
  const isSelfAssessment = containerType === "SelfAssessment";

  return (
    <div
      className={classNameBuilder({
        sidebar: true,
      })}
    >
      <div className={styles.sidebarHeader}>
        <H4>
          {isSelfAssessment && "Selvtest:"} {title}
        </H4>
        {progress}
      </div>
      <KurssloeyfeElementNavList />
      <div className={styles.sidebarBottom}>
        {isSelfAssessment && <SelfAssessmentDelivery />}
        {children}
        {canUpdateDetails && (
          <SubText>
            <Link to={urls.kurssloeyfeAdminEdit(containerId)}>
              Rediger detaljer
            </Link>
            <br />
            <Link to={urls.kurssloeyfeAdmin(containerId)}>
              Rediger elementer
            </Link>
          </SubText>
        )}
      </div>
    </div>
  );
};
